const STATUS_PENDING = 'new';
const STATUS_ENABLED = 'approved';
const STATUS_REJECTED = 'rejected';
const STATUS_DISABLED = 'inactive';
const STATUS_ANY = '*';
const MAX_BOOK_UPLOAD_FILES = 60;
const MIN_LOST_VISION_PERCENT = 50;
const BOOK_ARCHIVE_STATUS_PENDING = 'PENDING';
const BOOK_ARCHIVE_STATUS_DOWNLOADING_FILES = 'DOWNLOADING_FILES';
const BOOK_ARCHIVE_STATUS_CREATING_ARCHIVE = 'CREATING_ARCHIVE';
const BOOK_ARCHIVE_STATUS_UPLOADING_ARCHIVE = 'UPLOADING_ARCHIVE';
const BOOK_ARCHIVE_STATUS_CREATED = 'CREATED';
const BOOK_ARCHIVE_STATUS_DELETING = 'DELETING';
const BOOK_ARCHIVE_STATUS_FAILED = 'FAILED';
const AUTH_ERROR_INVALID_CREDENTIALS = 'AUTH_INVALID_CREDENTIALS';
const AUTH_ERROR_ACCOUNT_DISABLED = 'AUTH_ACCOUNT_DISABLED';
const AUTH_ERROR_ACCOUNT_NOT_APPROVED = 'AUTH_ACCOUNT_NOT_APPROVED';
const AUTH_ERROR_EMAIL_NOT_VERIFIED = 'AUTH_EMAIL_NOT_VERIFIED';
const AUTH_ERROR_UNAUTHORIZED = 'AUTH_UNAUTHORIZED';

module.exports = {
	STATUS_PENDING,
	STATUS_ENABLED,
	STATUS_REJECTED,
	STATUS_DISABLED,
	STATUS_ANY,
	MAX_BOOK_UPLOAD_FILES,
	MIN_LOST_VISION_PERCENT,
	BOOK_ARCHIVE_STATUS_PENDING,
	BOOK_ARCHIVE_STATUS_DOWNLOADING_FILES,
	BOOK_ARCHIVE_STATUS_CREATING_ARCHIVE,
	BOOK_ARCHIVE_STATUS_UPLOADING_ARCHIVE,
	BOOK_ARCHIVE_STATUS_CREATED,
	BOOK_ARCHIVE_STATUS_DELETING,
	BOOK_ARCHIVE_STATUS_FAILED,
	AUTH_ERROR_INVALID_CREDENTIALS,
	AUTH_ERROR_ACCOUNT_DISABLED,
	AUTH_ERROR_ACCOUNT_NOT_APPROVED,
	AUTH_ERROR_EMAIL_NOT_VERIFIED,
	AUTH_ERROR_UNAUTHORIZED,

	STATUSES: [
		STATUS_PENDING,
		STATUS_ENABLED,
		STATUS_REJECTED,
		STATUS_DISABLED,
		STATUS_ANY,
	],

	VERIFY_TOKEN_LENGTH: 32,
	RESET_TOKEN_LENGTH: 32,

	JWT_REGEX: /^Bearer [A-Za-z0-9-=]+.[A-Za-z0-9-=]+.?[A-Za-z0-9-_=]*$/,
	PASSWORD_REGEX: /^(?=.*[a-z])(?=.*\d|.*[!@#$%^&*])(?=.*[A-Z])(?:.{8,})$/,

	MIN_USERNAME_LENGTH: 4,
	JWT_EXPIRY: '168h',

	URL_API_SIGN_IN: 'sign-in',
	URL_API_SIGN_UP: 'sign-up',
	URL_API_ADD_IMAGE: 'sign-up-add-image',

	URL_BOOK_GET: 'book',

	URL_API_ADMIN_GET_NOTIFICATIONS: 'notifications',
	URL_API_ADMIN_GET_USERS: 'users',
	URL_API_ADMIN_GET_STATUSES: 'statuses',
	URL_API_ADMIN_DELETE_USER: 'user',

	FALSE_TELK_URL: 'invalid',

	// MYHOST: 'https://new.webaudio.stackport.com',
	MYHOST: `${window.location.protocol}//${window.location.host}`,

	ADMIN_USERNAME: 'admin',

	PAGINATED_DEFAULT_COUNT: 10,

	ORGANIZATIONS: [
		'---------', // 0, Empty
		'РСО СОФИЯ', // 1
		'РСО ВАРНА', // 2
		'РСО ПЛОВДИВ',
		'РСО МОНТАНА',
		'РСО ПЛЕВЕН',
		'РСО СЛИВЕН',
		'РСО СТАРА ЗАГОРА',
		'РСО БЛАГОЕВГРАД',
		'РСО БУРГАС',
		'РСО РУСЕ',
		'РСО ШУМЕН',
		'РСО ГАБРОВО',
		'РСО СИЛИСТРА',
		'РСО СМОЛЯН',
		'РСО КЪРДЖАЛИ',
		'Не членувам',
	],
};
